import { useEffect } from "react";

const CANON = "https://districtgreenzdmv.com";

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export default function Seo({ title, description, path = "/" }) {
    useEffect(() => {
        if (!process.env.REACT_APP_ALLOW_INDEXING) {
            let noindex = document.head.querySelector('meta[name="robots"]');
            if (!noindex) {
                noindex = document.createElement("meta");
                noindex.setAttribute("name", "robots");
                document.head.appendChild(noindex);
            }
            noindex.setAttribute("content", "noindex, nofollow");
        }
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", `${CANON}${path}`);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", `${CANON}${path}`);
    }, [title, description, path]);
    return null;
}
